import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Section } from '../../template-generator/entity/section';
import { TemplateService } from '../../template-generator/service/template.service';
import { DOCUMENT } from '@angular/common';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-index-section-generator',
  templateUrl: './index-section-generator.component.html',
  styleUrls: ['./index-section-generator.component.scss']
})
export class IndexSectionGeneratorComponent implements OnInit {
  sections: Array<Section>;

  constructor(
    private templateService: TemplateService,
    private serverConfigService: ServerConfigService,
    private render: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    protected translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.render.setAttribute(this.document.head.querySelector('link[rel="canonical"]'), 'href', `${this.serverConfigService.origin}/${this.translateService.currentLang}`);
    this.render.setAttribute(this.document.head.querySelector('meta[property="og:url"]'), 'content', `${this.serverConfigService.origin}/${this.translateService.currentLang}`);
    this.render.setAttribute(this.document.head.querySelector('meta[name="twitter:url"]'), 'content', `${this.serverConfigService.origin}/${this.translateService.currentLang}`);
    this.templateService.siteInfo$.subscribe(siteInfo => this.sections = siteInfo.template.sections);
  }
}
